import React from 'react';

const baseUrl = process.env.REACT_APP_API_BASE_URL;

interface LogoutButtonProps {
    onLogoutSuccess: () => void;
}

const LogoutButton: React.FC<LogoutButtonProps> = ({ onLogoutSuccess }) => {
    const handleLogout = async () => {
        try {
            const response = await fetch(`${baseUrl}/api/admin/auth/logout`, {
                method: 'POST',
                credentials: 'include',
            });

            if (!response.ok) {
                throw new Error('로그아웃에 실패했습니다.');
            }

            onLogoutSuccess();
        } catch (error) {
            console.error('로그아웃 중 오류가 발생했습니다.', error);
            alert('로그아웃에 실패했습니다. 다시 시도해 주세요.');
        }
    };

    return (
        <button onClick={handleLogout}>
            로그아웃
        </button>
    );
};

export default LogoutButton;
